import classNames from '@/external/classNames';

type Props = {
  selected: boolean;
  onClick: () => void;
  isBitcasino: boolean;
};

const ToggleButton: FC<Props> = ({
  children,
  selected,
  onClick,
  isBitcasino,
}) => (
  <div
    className={classNames(
      'inline-container flex h-10 items-center justify-center rounded-moon-s-xs font-medium',
      'm-1 cursor-pointer border border-solid border-beerus hover:bg-piccolo hover:text-goten',
      isBitcasino && 'hover:text-goku',
      selected && 'bg-piccolo text-goten',
      selected && isBitcasino && 'bg-piccolo text-goku',
    )}
    onClick={onClick}
  >
    {children}
  </div>
);

export default ToggleButton;
